/* eslint-disable linebreak-style */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable quotes */
import React, {useEffect} from "react";
import { Helmet } from "react-helmet";
import {Route, Switch, useHistory, useLocation} from "react-router-dom";
import {connect} from "react-redux";
import * as PropTypes from "prop-types";
import "../../styles/styles.scss";
import ManageNav from "./ManageNav";
import NotFoundPage from "../NotFoundPage";
import Teacher from "./Teacher";
import Teachers from "./Teachers";
import Client from "./Client";
import ClientLedger from "./ClientLedger";
import ClientNotificationHistory from "./ClientNotificationHistory";
import Clients from "./Clients";
import Dashboard from "./Dashboard";
import Student from "./Student";
import Students from "./Students";
import SchoolClass from "./SchoolClass";
import SchoolClasses from "./SchoolClasses";
import Login from "./Login";
import PasswordResetRequest from "./PasswordResetRequest";
import PasswordResetConfirm from "./PasswordResetConfirm";
import {ROLES as ROLE} from "../common/Const";
import * as userActions from "../../redux/actions/usersActions";
import Book from "./Book";
import Books from "./Books";
import HeaderNav from "../HeaderNav";
import AttendanceReport from "../report/AttendanceReport";
import ClientSettlementsReport from "../report/ClientSettlementsReport";
import * as settingsActions from "../../redux/actions/settingsActions";
import { buildSchoolYearOptions } from "../common/schoolYear";
import {
  buildSearchWithSchoolYear,
  getNormalizedSchoolYearStartYearFromSearch,
} from "./manageSchoolYearRouting";
import {
  canAccessManagePath,
  canReadBooks,
  canReadClients,
  canReadPayments,
  isManageRole,
} from "./rbac";

export function ManagementPage({
  user,
  signOut,
  checkToken,
  activeSchoolYearStartYear,
  setActiveSchoolYearStartYear,
}) {
  const history = useHistory();
  const location = useLocation();
  const selectorOptions = buildSchoolYearOptions();
  const isAuthenticated = user && isManageRole(user.role);
  const hasUnsupportedRole = Boolean(user && user.role !== ROLE.GUEST && !isAuthenticated);
  const normalizedStartYear = getNormalizedSchoolYearStartYearFromSearch(location.search);
  const normalizedSearch = buildSearchWithSchoolYear(location.search, normalizedStartYear);
  const isSchoolYearHydrated = !isAuthenticated || (
    activeSchoolYearStartYear === normalizedStartYear
    && location.search === normalizedSearch
  );
  const menuItems = [
    { name: "Dashboard", route: "/manage/" },
    { name: "Nauczyciele", route: "/manage/teachers" },
    { name: "Klienci", route: "/manage/clients" },
    { name: "Uczniowie", route: "/manage/students" },
    { name: "Zajęcia", route: "/manage/classes" },
    { name: "Książki", route: "/manage/books" },
    { name: "Raporty", route: "/manage/reports" },
    { name: "Rozliczenia", route: "/manage/reports/client-settlements" },
  ];
  const roleMenuItems = menuItems.filter((item) => {
    if (!user) return false;
    if (item.route === "/manage/teachers") return user.role !== ROLE.TEACHER;
    if (item.route.startsWith("/manage/clients")) return canReadClients(user.role);
    if (item.route.startsWith("/manage/books")) return canReadBooks(user.role);
    if (item.route.startsWith("/manage/reports/client-settlements")) return canReadPayments(user.role);
    return true;
  });
  const canAccessCurrentPath = isAuthenticated && canAccessManagePath(user.role, location.pathname);

  useEffect(() => {
    if (!user || user.role === ROLE.GUEST) checkToken();
  }, [checkToken, user]);

  useEffect(() => {
    if (!isAuthenticated) return;

    if (normalizedStartYear !== activeSchoolYearStartYear) {
      setActiveSchoolYearStartYear(normalizedStartYear);
    }

    if (normalizedSearch !== location.search) {
      history.replace({ pathname: location.pathname, search: normalizedSearch });
    }
  }, [
    activeSchoolYearStartYear,
    history,
    isAuthenticated,
    location.pathname,
    location.search,
    normalizedSearch,
    normalizedStartYear,
    setActiveSchoolYearStartYear,
  ]);

  const handleSchoolYearChange = (startYear) => {
    setActiveSchoolYearStartYear(startYear);
    history.replace({
      pathname: location.pathname,
      search: buildSearchWithSchoolYear(location.search, startYear),
    });
  };

  return (
    <div >
      <Helmet>
        <title>Extra English - zarządzanie</title>
      </Helmet>

      { (!user || user.role === ROLE.GUEST) && location.pathname === "/manage/password-reset" && (
        <>
          <HeaderNav />
          <div className="quiz-page row m-0 p-0 d-flex justify-content-center align-items-center">
            <div className="col-lg-8 col-11" >
              <PasswordResetRequest />
            </div>
          </div>
        </>
      )}

      { (!user || user.role === ROLE.GUEST) && location.pathname.startsWith("/manage/password-reset/") && (
        <>
          <HeaderNav />
          <div className="quiz-page row m-0 p-0 d-flex justify-content-center align-items-center">
            <div className="col-lg-8 col-11" >
              <Route path="/manage/password-reset/:token" component={PasswordResetConfirm} />
            </div>
          </div>
        </>
      )}

      { (!user || user.role === ROLE.GUEST) && location.pathname !== "/manage/password-reset" && !location.pathname.startsWith("/manage/password-reset/") && (
        <>
          <HeaderNav />
          <div className="quiz-page row m-0 p-0 d-flex justify-content-center align-items-center">
            <div className="col-lg-8 col-11" >
              {location.state && location.state.passwordResetMessage && (
                <div className="alert alert-info" role="alert">{location.state.passwordResetMessage}</div>
              )}
              <Login />
            </div>
          </div>
        </>
      )}

      { hasUnsupportedRole && (
        <>
          <HeaderNav />
          <div className="manage-container row m-0 d-flex justify-content-center">
            <div className="col-lg-10 col-11 mt-lg-5 mt-3">
              <div className="alert alert-danger manage-text" role="alert">Brak uprawnien</div>
              <button
                type="button"
                className="btn manage-red-button manage-button"
                onClick={signOut}
              >
                Wyloguj
              </button>
            </div>
          </div>
        </>
      )}

      { isAuthenticated && isSchoolYearHydrated && (
        <div>
          <ManageNav
            items={roleMenuItems}
            signOut={signOut}
            currentSearch={location.search}
            activeSchoolYearStartYear={activeSchoolYearStartYear}
            schoolYearOptions={selectorOptions}
            onActiveSchoolYearChange={handleSchoolYearChange}
          />
          <div className="manage-container row m-0 d-flex justify-content-center">
            <div className="col-lg-10 col-11 mt-lg-5 mt-3" id="parent" >
              {!canAccessCurrentPath ? (
                <div className="alert alert-danger manage-text" role="alert">Brak uprawnien</div>
              ) : (
                <Switch>
                  <Route
                    path="/manage"
                    render={() => (
                      <Dashboard
                        userId={user.id}
                        userRole={user.role}
                        userTeacherId={user.teacherId}
                        onActiveSchoolYearChange={handleSchoolYearChange}
                      />
                    )}
                    exact
                  />
                  <Route path="/manage/teacher/:id" component={Teacher} />
                  <Route path="/manage/teachers" component={Teachers} exact />
                  <Route path="/manage/client/:id/ledger" component={ClientLedger} />
                  <Route path="/manage/client/:id/notifications" component={ClientNotificationHistory} />
                  <Route path="/manage/client/:id" component={Client} />
                  <Route path="/manage/clients" component={Clients} exact />
                  <Route path="/manage/student/:id" component={Student} />
                  <Route path="/manage/students" component={Students} exact />
                  <Route path="/manage/class/:id" component={SchoolClass} />
                  <Route path="/manage/classes" component={SchoolClasses} exact />
                  <Route path="/manage/book/:id" component={Book} />
                  <Route path="/manage/books" component={Books} exact />
                  <Route path="/manage/reports/client-settlements" component={ClientSettlementsReport} exact />
                  <Route path="/manage/reports" render={() => <AttendanceReport userId={user.id} userRole={user.role} />} exact />
                  <Route path="/manage/login" component={Login} exact />
                  <Route component={NotFoundPage} exact />
                </Switch>
              )}
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

ManagementPage.propTypes = {
  user: PropTypes.object.isRequired,
  signOut: PropTypes.func.isRequired,
  checkToken: PropTypes.func.isRequired,
  activeSchoolYearStartYear: PropTypes.number.isRequired,
  setActiveSchoolYearStartYear: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  user: state.user,
  activeSchoolYearStartYear: state.settings.activeSchoolYearStartYear,
});

const mapDispatchToProps = {
  signOut: userActions.signOut,
  checkToken: userActions.checkToken,
  setActiveSchoolYearStartYear: settingsActions.setActiveSchoolYearStartYear,
};


export default connect(mapStateToProps, mapDispatchToProps)(ManagementPage);
